import { axios, Response } from '../index'

type ResponseBody = {
  id: string
  name: string
  groupVisibility: 'PUBLIC' | 'PRIVATE'
  groupSendPermission: 'ADMIN' | 'ALL_MEMBERS'
}

export interface RequestBody {
  id: string
  name: string
  postEdit: 'CREATOR_ONLY' | 'ANYONE' | 'PLACEHOLDER'
  groupVisibility: string
  groupSendPermission: string
  patientIds: string[]
  expirationDate: string | null
  imageRequest?: ImageRequest
  headerRequest?: HeaderRequest
  clonePostGroupId: string | null
  groupPermissionFixed: 'ADMIN' | 'ALL_MEMBERS'
  comment: 'ADMIN' | 'ALL_MEMBERS'
  automaticDeletedPost: 'ADMIN' | 'ALL_MEMBERS'
}

export interface ImageRequest {
  fileName: string
  fileContentType: string
}

export interface HeaderRequest {
  fileName: string
  fileContentType: string
}

export interface InitialRequest {
  whoReceivedInviteId: string
}

const createGroup = (body: RequestBody): Response<ResponseBody> => {
  return axios.post('/v1/groups', body)
}

export default createGroup
